import { Link } from 'react-router-dom';
import { SEO } from '../../seo/useSEO';
import { t } from '../../i18n/pt';
import { Button } from '../../components/ui/Button';
import styles from './SobreRositaPage.module.scss';

export default function SobreRositaPage(): JSX.Element {
  return (
    <div className={styles.page}>
      <SEO title={t.about.title} description={t.about.storyLead} />

      <nav className={styles.breadcrumb} aria-label={t.common.breadcrumb}>
        <div className={styles.breadcrumbInner}>
          <Link to="/" className={styles.breadcrumbHome}>
            {t.products.breadcrumbHome}
          </Link>
          <span aria-hidden> / </span>
          <span className={styles.breadcrumbCurrent}>
            {t.about.breadcrumbCurrent}
          </span>
        </div>
      </nav>

      {/* Hero — blush band with roses */}
      <section className={styles.hero}>
        <img
          src="/home/rose-big-1.svg"
          alt=""
          aria-hidden
          className={`${styles.heroRose} ${styles.heroRoseLeft}`}
        />
        <img
          src="/home/rose-big-2.svg"
          alt=""
          aria-hidden
          className={`${styles.heroRose} ${styles.heroRoseRight}`}
        />
        <div className={styles.heroInner}>
          <p className={styles.heroEyebrow}>{t.about.eyebrow}</p>
          <div className={styles.heroTitle}>
            <h1 className={styles.heroHeading}>{t.about.title}</h1>
            <p className={styles.heroScript}>{t.about.script}</p>
          </div>
        </div>
      </section>

      {/* Story */}
      <section className={styles.story}>
        <div className={`container-wide ${styles.storyInner}`}>
          <div className={styles.storyText}>
            <h2 className={`h1-display ${styles.storyHeading}`}>
              {t.about.storyTitleA}
              <span className="accent">{t.about.storyTitleAccent}</span>
              {t.about.storyTitleB}
            </h2>
            <p className={styles.storyLead}>{t.about.storyLead}</p>
            {t.about.storyParagraphs.map((p, i) => (
              <p key={i} className={styles.storyParagraph}>
                {p}
              </p>
            ))}
          </div>
          <figure className={styles.storyPortrait}>
            <img src="/home/story.webp" alt="Rosita" />
          </figure>
        </div>
      </section>

      {/* Values — burgundy band */}
      <section className={styles.values}>
        <div className={`container-wide ${styles.valuesInner}`}>
          <h2 className={styles.valuesTitle}>
            {t.about.valuesTitle}{' '}
            <em className={styles.valuesTitleAccent}>
              {t.about.valuesTitleAccent}
            </em>
          </h2>
          <div className={styles.valuesGrid}>
            {t.about.values.map((value, i) => (
              <article key={value.title} className={styles.valueCard}>
                <span className={styles.valueNumber}>
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className={styles.valueTitle}>{value.title}</h3>
                <p className={styles.valueBody}>{value.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Closing CTA */}
      <section className={styles.closing}>
        <div className={styles.closingInner}>
          <h2 className={styles.closingTitle}>
            {t.about.closingTitleA}
            <br />
            {t.about.closingTitleB}
            <em className={styles.closingTitleAccent}>
              {t.about.closingTitleAccent}
            </em>
            {t.about.closingTitleC}
          </h2>
          <Button variant="primary" size="lg" to="/produtos">
            {t.about.cta}
          </Button>
        </div>
      </section>
    </div>
  );
}
